import { GET_AWBS_SUCCEEDED, GET_AWBS_EXPORT_SUCCEEDED, GET_AWBS_GHA_SUCCEEDED, GET_AWBS_OFFLINE_SUCCEEDED, CLEAR_AWBS_OFFLINE_DATA } from './actionTypes';

import awbRemote from '../../api/awbRemote';
import pickupOrderRemote from '../../api/pickupOrderRemote';
import offlineRfsRemote from '../../api/offlineRfsRemote';

import Awb from '../../models/Awb';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';

import { receiveError } from './notificationAction';

function awbsSuccess(resp: Awb[]) {
  return {
      type: GET_AWBS_SUCCEEDED,
      payload: resp
  }
}

function awbsExportSuccess(resp: Awb[]) {
  return {
      type: GET_AWBS_EXPORT_SUCCEEDED,
      payload: resp
  }
}

function awbsGhaSuccess(resp: Awb[]) {
  return {
      type: GET_AWBS_GHA_SUCCEEDED,
      payload: resp
  }
}

function awbsOfflineSuccess(resp: Awb[]) {
  return {
      type: GET_AWBS_OFFLINE_SUCCEEDED,
      payload: resp
  }
}

function awbsOfflineClearData() {
  return {
    type: CLEAR_AWBS_OFFLINE_DATA
  };
};

function receiveAwbs(port: string, gha: number, delivered?: boolean, paid?: boolean, unpaid?: boolean, keyword?: string, sortby?: string, filterby?: string) {

  return (dispatch: any) => {

    awbRemote.getImportAwbs(port, gha, delivered, paid, unpaid, keyword, sortby, filterby).then((resp: ApiResponse<Awb[]>) => {

      const awbs: Awb[] | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awbs) {
        dispatch(awbsSuccess(awbs));
      } 
      
      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
}

function receiveExportAwbs(port: string, gha: number, completed?: boolean, keyword?: string, sortby?: string) {

  return (dispatch: any) => {

    awbRemote.getExportAwbs(port, gha, completed, keyword, sortby).then((resp: ApiResponse<Awb[]>) => {

      const awbs: Awb[] | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awbs) {
        dispatch(awbsExportSuccess(awbs));
      } 
      
      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
}

function receiveGhaAwbs(isExport: boolean) {

  return (dispatch: any) => {

    awbRemote.getGhaAwbList(isExport).then((resp: ApiResponse<Awb[]>) => {

      const awbs: Awb[] | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awbs) {
        dispatch(awbsGhaSuccess(awbs));
      } 
      
      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
}

function receiveGhaOrderAwbs(orderNumber: string) {

  return (dispatch: any) => {

    pickupOrderRemote.getGhaOrderAwbs(orderNumber).then((resp: ApiResponse<Awb[]>) => {

      const awbs: Awb[] | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awbs) {
        dispatch(awbsGhaSuccess(awbs));
      } 
      
      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
}

function receiveOfflineOrderAwbs(orderNumber: string) {

  return (dispatch: any) => {

    offlineRfsRemote.getOfflineOrderAwbs(orderNumber).then((resp: ApiResponse<Awb[]>) => {

      const awbs: Awb[] | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awbs) {
        dispatch(awbsOfflineSuccess(awbs));
      } 
      
      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
}

export {
  receiveAwbs,
  receiveExportAwbs,
  receiveGhaAwbs,
  receiveGhaOrderAwbs,
  receiveOfflineOrderAwbs,
  awbsOfflineClearData
}